import * as React from 'react'
import './index.scss'
import logo from '../../images/logo_black.svg'
import {NavigationItem} from './sidebar'
import SideBarItem from "./SideBarItem";
import {rolesRight} from '../../containers/Main/routes'
import {FormattedMessage} from "react-intl";
import {ROLES} from "../../reducers/types";

interface IProps {
    navigationItems?: Array<NavigationItem>,
    role: ROLES
}

interface IState {
    collapsed: boolean
}

export default class SideBar extends React.Component<IProps, IState> {
    constructor(props: IProps) {
        super(props)
        this.state = {
            collapsed: false
        }
    }

    getRole = (role: ROLES) => {

        return  ROLES[role]
    }

    public renderSideBar = (sidebar: Array<NavigationItem>): JSX.Element[] | null => {
        if(this.props.role !== ROLES.NONE){
            // console.log(rolesRight, ROLES[this.props.role])
            type roleType = 'ADMIN' | "CASHIER" | 'SUPER_ADMIN' | 'NONE'
            let role: keyof typeof ROLES = ROLES[this.props.role] as roleType
            let rightList = rolesRight[role]
            let html = []
            for(var i in sidebar){
                html.push(<SideBarItem rightList={rightList}
                                       item={sidebar[i]}
                                       key={`${sidebar[i].name}-${i}`}/>)
            }
            return html
        }
        return null
    }
    onToggle = () => {
        this.setState({
            collapsed: !this.state.collapsed
        })
    }

    public render() {
        let {navigationItems} = this.props
        return (
            <div className={`sideBar ${this.state.collapsed ? 'collapsed' : ''}`}>
                <div className="logo-container">
                    <div className="logo">
                        <img src={logo} alt="ScanForPay"/>
                    </div>
                </div>
                <div className="content">
                    {navigationItems ? this.renderSideBar(navigationItems) : null}
                </div>
                {this.state.collapsed ?
                    <div className="collapseButton" onClick={this.onToggle}>
                        <span className="rightArrow"></span>
                    </div> :
                    <div className="collapseButton" onClick={this.onToggle}>
                        <span className="leftArrow"></span>
                        <span className="text"><FormattedMessage id="collapse"/></span>
                    </div>}
            </div>
        );
    }
}